




























































































































import { ApiGroupBuyingOrderGroupOrderInfoResponse } from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { default as GroupBuyingContentRule } from './content_rule.vue'
import { RequiredDeep } from 'vtils/types'
import { showSkuPicker } from '@/views/goods/exports'
import { wait } from 'vtils'

export default defineClassComponent<{
  data: RequiredDeep<ApiGroupBuyingOrderGroupOrderInfoResponse>
  noRule?: boolean
}>(
  {
    components: {
      GroupBuyingContentRule,
    },
    props: ['data', 'noRule'],
  },
  ({ props, ctx }) =>
    class {
      // 更多数据
      moreData = computed(
        () => props.data.groupData.otherOrders || props.data.groupData,
      )

      // 是否显示更多
      showMore = ref(false)

      // 点击显示更多
      handleMoreClick = () => {
        this.showMore.value = true
      }

      // 点击关闭更多弹窗
      handleCloseClick = () => {
        this.showMore.value = false
      }

      handleGroupBuyingClick = (
        // eslint-disable-next-line no-undef
        item: (typeof this)['moreData']['value']['groupItems'][0],
      ) => {
        showSkuPicker({
          goodsId: item.commodityId,
          action: 'groupBuying',
          groupBuyingOrderId: item.orderId,
        })
      }

      handleGroupBuyingCountdownEnd = () => {
        wait(2000).then(() => ctx.$emit('countdownend'))
      }
    },
)
